/*** IMPORTS FROM imports-loader ***/
var global = window;

'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;

